<template>
  <div class="arena-create-dialog">
    <el-dialog
      :visible.sync="visible"
      @open="opened"
      @closed="closed"
      title="新增专题"
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="160px">
        <el-form-item prop="languageCode" label="语言">
          <el-tabs v-model="languageCode">
            <el-tab-pane
              v-for="(item, index) in languages"
              :key="index"
              :name="item.value"
              :label="item.label"
            ></el-tab-pane>
          </el-tabs>
        </el-form-item>
        <div
          v-for="(item, index) in form.detailList"
          :key="index"
          v-show="item.languageCode == languageCode"
        >
          <el-form-item
            :prop="'detailList[' + index + '].arenaName'"
            label="专题名称"
          >
            <el-input v-model="item.arenaName"></el-input>
          </el-form-item>
          <el-form-item
            :prop="'detailList[' + index + '].intro'"
            label="活动说明"
          >
            <el-input type="textarea" v-model="item.intro"></el-input>
          </el-form-item>
          <el-form-item :prop="'detailList[' + index + '].period'" label="期数">
            <el-input v-model="item.period"></el-input>
          </el-form-item>
          <el-form-item
            :prop="'detailList[' + index + '].useRange'"
            label="适用范围"
          >
            <el-input type="textarea" v-model="item.useRange"></el-input>
          </el-form-item>
          <el-form-item
            :prop="'detailList[' + index + '].awardsRange'"
            label="奖项设置"
          >
            <el-input type="textarea" v-model="item.awardsRange"></el-input>
          </el-form-item>
        </div>
        <el-form-item prop="webImageUrl" label="背景图片(web)：">
          <upload v-model="form.webImageUrl"></upload>
        </el-form-item>
        <el-form-item label="背景图片(h5)：" prop="h5ImageUrl">
          <upload v-model="form.h5ImageUrl"></upload>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-date-picker
            v-model="timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="productType" label="产品类型">
          <el-select v-model="form.productType">
            <el-option
              v-for="(item, index) in productTypes"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="firstParams" label="标的">
          <el-input
            v-model="form.firstParams"
            placeholder="输入交易对或者币种"
          ></el-input>
        </el-form-item>
        <el-form-item prop="dataIndex" label="排名指标">
          <el-select v-model="form.dataIndex">
            <el-option
              v-for="(item, index) in rankTypes"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="rankingCount" label="排名数量">
          <el-select v-model="form.rankingCount">
            <el-option :value="10" label="TOP 10"></el-option>
            <el-option :value="30" label="TOP 30"></el-option>
            <el-option :value="50" label="TOP 50"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="updateFrequency" label="更新频率">
          <el-select v-model="form.updateFrequency">
            <el-option :value="30" label="半小时"></el-option>
            <el-option :value="60" label="1小时"></el-option>
            <el-option :value="240" label="4小时"></el-option>
            <el-option :value="360" label="6小时"></el-option>
            <el-option :value="720" label="12小时"></el-option>
            <el-option :value="1440" label="1天"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="linkUrl" label="打榜链接(web)">
          <el-input v-model="form.linkUrl"></el-input>
        </el-form-item>
        <el-form-item prop="rankingInsert" label="排名数据插入">
          <el-input
            v-model="form.rankingInsert"
            placeholder="以,隔开"
          ></el-input>
        </el-form-item>
        <el-form-item prop="rankingInsert" label="第一名偏移量">
          <el-input v-model="form.firstExcursion"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Upload from "components/upload";
import { PRODUCT_TYPES, RANK_TYPES, LANGUAGES } from "../constants.js";
export default {
  props: ["type", "aid"],
  data() {
    return {
      visible: false,
      productTypes: PRODUCT_TYPES,
      rankTypes: RANK_TYPES,
      languages: LANGUAGES,
      languageCode: "zh",
      timeRange: [],
      form: {
        webImageUrl: "",
        h5ImageUrl: "",
        updateFrequency: "",
        firstParams: "",
        secondParams: "",
        rankingCount: "",
        rankingInsert: "",
        startTime: "",
        endTime: "",
        dataIndex: "",
        linkUrl: "",
        firstExcursion: "",
        detailList: [
          {
            arenaName: "",
            awardsRange: "",
            intro: "",
            languageCode: "zh",
            period: "",
            useRange: "",
          },
          {
            arenaName: "",
            awardsRange: "",
            intro: "",
            languageCode: "en",
            period: "",
            useRange: "",
          },
          {
            arenaName: "",
            awardsRange: "",
            intro: "",
            languageCode: "kr",
            period: "",
            useRange: "",
          },
          {
            arenaName: "",
            awardsRange: "",
            intro: "",
            languageCode: "vi",
            period: "",
            useRange: "",
          },
        ],
      },
      rules: {},
    };
  },
  methods: {
    ...mapActions("arena", ["create", "getDetail", "update"]),
    setVisible(val) {
      this.visible = val;
    },
    submit() {
      let subForm = { ...this.form };
      if (this.timeRange.length > 1) {
        if (this.timeRange[0]) subForm.startTime = this.timeRange[0].getTime();
        if (this.timeRange[1]) subForm.endTime = this.timeRange[1].getTime();
      }
      if (subForm.rankingInsert)
        subForm.rankingInsert = JSON.stringify(
          subForm.rankingInsert.replace(/，/g, ",").split(",")
        );
      subForm.firstExcursion = parseFloat(subForm.firstExcursion);
      let tempDetailList = [];
      subForm.detailList.forEach((v, i, a) => {
        if(v.arenaName || v.awardsRange || v.intro || v.period || v.useRange) tempDetailList.push(v);
      });
      subForm.detailList = tempDetailList;
      if (this.type == "create") {
        this.create(subForm).then((res) => {
          let type = res.code == 0 ? "success" : "error";
          this.$message({
            showClose: true,
            message: res.msg,
            type,
          });
          if (res.code == 0) {
            this.visible = false;
            this.$emit("submitData");
          }
        });
      }
      if (this.type == "update") {
        this.update(subForm).then((res) => {
          let type = res.code == 0 ? "success" : "error";
          this.$message({
            showClose: true,
            message: res.msg,
            type,
          });
          if (res.code == 0) {
            this.visible = false;
            this.$emit("submitData");
          }
        });
      }
    },
    opened() {
      if (this.type == "update") {
        this.getDetail({ id: this.aid }).then((res) => {
          if (!res.code) {
            let detailList = res.data.detailList || [];
            ["zh", "en", "kr", "vi"].forEach((v, i, a) => {
              let f = detailList.find((vr, ir, ar) => {
                return vr.languageCode == v;
              });
              if (!f) {
                detailList.push({
                  arenaName: "",
                  awardsRange: "",
                  intro: "",
                  languageCode: v,
                  period: "",
                  useRange: "",
                });
              }
            });
            res.data.detailList = detailList;
            this.form = res.data;
            if (this.form.rankingInsert)
              this.form.rankingInsert = this.form.rankingInsert.join(",");
            this.timeRange.push(new Date(res.data.startTime));
            this.timeRange.push(new Date(res.data.endTime));
          }
        });
      }
    },
    closed() {
      this.$refs["form"].resetFields();
      this.timeRange = [];
      this.languageCode = "zh";
    },
  },
  components: {
    Upload,
  },
};
</script>
<style lang="less">
.arena-create-dialog {
  .el-upload {
    .el-icon-upload {
      margin: 10px 0px;
    }
    .el-upload-dragger {
      width: 246px;
      height: 123px;
    }
  }
}
</style>
